<template>
  <transition :leave-active-class="transitionLeaveActiveClass">
    <owa-element-loading
      class="display-flex flex-column flex-items-center flex-content-center"
      :content="loadingMessage"
      :custom-style="{
        'min-height': 'var(--element-md-loading-min-height)'
      }"
    />
  </transition>
</template>

<script>
  import sample from 'lodash/sample'
  import { LOADING_QUIPS } from './loadingQuips'

  export default {
    name: 'IconsLoading',

    props: {
      transition: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        loadingMessage: sample(LOADING_QUIPS)
      }
    },

    computed: {
      transitionLeaveActiveClass() {
        return this.transition ? 'animate__animated animate__faster animate__fadeOut' : ''
      }
    }
  }
</script>
